/**
* Main auto save function
* Using for saving data when user make changes on editor
* @param data - data for saving in json format
* */
import {readContainer} from "../core/ConvertToJson.js";
import {CGEditorTopic} from "../CGEditorTopic.js";

export const autoSave = {
    init(data = null, time = 1000, component = null) {
        setTimeout(() => {
            this.save(data, component);
        }, time);
    },
    save(data, component) {
        //console.log('save')
        CGEditorTopic.saveLesson(null, component);
    },
};

window.autoSave = autoSave;
